import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { PieChart, pieChartDefaultProps } from "react-minimal-pie-chart";
import MaterialTable from "./components/MaterialTable";
import MaterialTableValues from "./components/MaterialTableValues";
import { useRecoilValue } from "recoil";
import Dropdown from "react-bootstrap/Dropdown";
import { DebounceInput } from "react-debounce-input";
import { ToastContainer } from "react-toastify";
import { Modal } from "react-bootstrap";
import {
  Co2TotalTodaySMData,
  Co2TotalTomorrowSMData,
  PowderAutomizationData,
  VolumePartReductionData,
  Co2ePowderScenarioMData,
  GreenEnergyMixData,
  InertGasReductionSMData,
  PowderAutomizationInput,
  VolumePartReductionInput,
  GreenEnergyMixInput,
  CO2eModeOfTransportNode1,
  CO2eModeOfTransportNode2,
  CO2eModeOfTranspotation1,
  CO2eModeOfTranspotation2,
  TotalTraspotation
} from "atoms/Co2Metal/ScenarioMetal";
import {
  Co2ePerPartTMDataM,
  Co2ePerYearDataM,
} from "atoms/Co2Metal/TransportationAtoms";
import {
  MachineNameDataM,
  MaterialNameDataM,
} from "atoms/Co2Metal/MachineDetailsAtoms";
import {
  Co2ePerJobDataM,
  Co2ePerPartPMDataM,
} from "atoms/Co2Metal/PowderMfgAtoms";
import {
  InertGasConsumptionDataM,
  InertGasUsedEnergyDataM,
} from "atoms/Co2Metal/InertGasAtoms";
import {
  EnergyBuildProcessDataM,
  EnergyPerPartDataM,
} from "atoms/Co2Metal/ElectricityConsumptionAtoms";
import {
  Co2EmissionBuildProcessDataM,
} from "atoms/Co2Metal/CarbonContentPerPartAtoms";

import ReportsTwo from "../ReportsTwoMetal";
import PdfGenerator from "./components/PdfGenerator";
import { GET_CLIENT_EMAILS } from "../ProcessMetal/components/getStepDetail";
import { useApolloClient } from '@apollo/react-hooks';
import { HotspotArray } from "atoms/General";
import "tippy.js/dist/tippy.css"; // optional
import MaterialTableValues1 from "../ScenarioMetal/components/MaterialTableValuesNew";

const ReportsMetal = ({ ScenarioState, socket,setTypeDocument,typedocument,setEmail,show,setShow }) => {
  const shiftSize = 7;
  const co2TotalToday = useRecoilValue(Co2TotalTodaySMData);
  const co2TotalTomorrow = useRecoilValue(Co2TotalTomorrowSMData);
  const powderAtomization = useRecoilValue(PowderAutomizationData);
  const powderAutomizationInput = useRecoilValue(PowderAutomizationInput);
  const volumePArtReduction = useRecoilValue(VolumePartReductionData);
  const volumePartReductionInput = useRecoilValue(VolumePartReductionInput);
  const co2ePowder = useRecoilValue(Co2ePowderScenarioMData);
  const greenenergymix = useRecoilValue(GreenEnergyMixData);
  const greenEnergyMixInput = useRecoilValue(GreenEnergyMixInput);
  const inertGasReduction = useRecoilValue(InertGasReductionSMData);
  const co2Transportation = useRecoilValue(Co2ePerPartTMDataM);
  const Tranpotation = useRecoilValue(TotalTraspotation)
  const [powder, setPowder] = useState();
  const [volume, setVolume] = useState();
  const [co2powder, setCO2ePowder] = useState();
  const [greenEnergyMix, setGreenEnergyMix] = useState();
  const [inertGas, setInertGas] = useState();
  const [transport, setTransport] = useState();
  const [savePdf, setSavePdf] = useState(false);
  const [donutImage, setDonutImage] = useState();
  // const [typedocument, setTypeDocument] = useState();
  const MachineNameMD = useRecoilValue(MachineNameDataM);
  const MaterialNameMD = useRecoilValue(MaterialNameDataM);
  const co2ePerJobMFG = useRecoilValue(Co2ePerJobDataM);
  const co2ePerPartbMFG = useRecoilValue(Co2ePerPartPMDataM);
  const inertGasConsumptionIG = useRecoilValue(InertGasConsumptionDataM);
  const inertGaUSedEnergyIG = useRecoilValue(InertGasUsedEnergyDataM);
  const energyBuildProcessEC = useRecoilValue(EnergyBuildProcessDataM);
  const energyPerPartEC = useRecoilValue(EnergyPerPartDataM);
  const co2PerPartT = useRecoilValue(Co2ePerPartTMDataM);
  const co2PerYearT = useRecoilValue(Co2ePerYearDataM);
  const HotsspotArray = useRecoilValue(HotspotArray)
  const [hotSpotArray, setHotSpotArray] = useState([])
  const [highestIndexHotspot, setHighestIndexHotspot] = useState()
  const client = useApolloClient();
  const [clientSteps, setClientSteps] = useState([]);
  // const [email, setEmail] = useState();
  const groupid = parseInt(sessionStorage.getItem("group_id"));
  const allCurrencies = JSON.parse(sessionStorage.getItem("all_currencies") || "[]");

  const currencySymbol = sessionStorage.getItem("currency");
  const  region = allCurrencies?.find(
    (r) => r.currency_symbol === currencySymbol
  );
  
  const [pdfName, setPdfName] = useState("");
  const handleClose = () => setShow(false);

  const co2EmissionBuildProcessCC = useRecoilValue(
    Co2EmissionBuildProcessDataM
  );

  const ModeOfTransportNode1 = useRecoilValue(CO2eModeOfTransportNode1);
  const ModeOfTransportNode2 = useRecoilValue(CO2eModeOfTransportNode2);
  const ModeOfTranspotation1 = useRecoilValue(CO2eModeOfTranspotation1);
  const ModeOfTranspotation2 = useRecoilValue(CO2eModeOfTranspotation2);

  const DataSet = [
    {
      name:"CO2e Powder:",
      color: "#5197F7",
       title: co2powder
        ? ((co2powder / co2TotalToday) * 100).toFixed(2) + "%"
        : "",
      value: parseFloat(((co2powder / co2TotalToday) * 100).toFixed(2)),
    },
    // TODO...
    // {
    //   color: "#9CEAEF",
    //   title: inertGas
    //     ? ((inertGas / co2TotalToday) * 100).toFixed(2) + "%"
    //     : "",
    //   value: parseFloat(((inertGas / co2TotalToday) * 100).toFixed(2)),
    // },
    {
      name:"CO2e Energy:",

      color: "#B7D5FB",
      title: greenEnergyMix && inertGas
        ? (((greenEnergyMix + inertGas) / co2TotalToday) * 100).toFixed(2) + "%"
        : "",
      value: parseFloat((((greenEnergyMix + inertGas) / co2TotalToday) * 100).toFixed(2)),
    },

    {
      name:"CO2e Logistics: ",

      color: "#A1A19D",
      title: Tranpotation?.today
        ? ((Tranpotation?.today / co2TotalToday) * 100).toFixed(2) + "%"
        : "",
      value: parseFloat(((Tranpotation?.today / co2TotalToday) * 100).toFixed(2)),
    },
  ];
  const initialDocumentState = () => {
    setTypeDocument(undefined);
    setPdfName("")
    setSavePdf(false)
  }
  useEffect(() => {
    client
      .query({
        query: GET_CLIENT_EMAILS,
        variables: { group_id: groupid },
      })
      .then(({ data, loading }) => {
        setClientSteps(data.getRegionsByUserGroup);
      })
      .catch((error) => {
        console.log("error in process", error);
        // toast.error(error.graphQLErrors[0].messasge.message)
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    for (let index = 0; index < clientSteps.length; index++) {
      if (clientSteps[index].name === region) {
        setEmail(clientSteps[index].email);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientSteps]);
  useEffect(() => {
    if (
      powderAtomization &&
      volumePArtReduction &&
      co2ePowder &&
      greenenergymix &&
      inertGasReduction
    ) {
      setPowder(parseFloat(powderAtomization.today));
      setCO2ePowder(parseFloat(co2ePowder.today));
      setVolume(parseFloat(volumePArtReduction.today));
      setInertGas(parseFloat(inertGasReduction.today));
      setGreenEnergyMix(parseFloat(greenenergymix.today));
      setTransport(parseFloat(co2Transportation));

      hotSpotArray.push(
        {
          "CO2e Powder": co2ePowder.today,
          "CO2e Energy": greenenergymix.today,
          "CO2e Logistics": co2Transportation
        }
      );
      setHotSpotArray(hotSpotArray);
    }
    const parent = document.getElementById("m2");
    const firstchild = parent.firstChild;
    firstchild.setAttribute("viewBox", "10 -12 100 125");
    setTimeout(() => {

      const s = new XMLSerializer().serializeToString(firstchild);
      const encodedData = window.btoa(s);
      // Checking image encoded data base64....
      // console.log("data:image/svg+xml;base64," + encodedData);
      setDonutImage("data:image/svg+xml;base64," + encodedData);
      const canva = document.createElement("canvas");
      canva.width = 600;
      canva.height = 600;
      var ctx = canva.getContext("2d");
      const Imgsrc = "data:image/svg+xml;base64," + encodedData;
      const Img = new Image();
      Img.src = Imgsrc;
      Img.onload = function () {
        ctx.drawImage(Img, 0, 0);
        var pngsrc = canva.toDataURL("image/png");

        setDonutImage(pngsrc);
      };


    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    powderAtomization,
    volumePArtReduction,
    co2ePowder,
    greenenergymix,
    inertGasReduction,
  ]);
  useEffect(() => {
    if (hotSpotArray.length !== 0) {

      // const max = Math.max(...hotSpotArray);
      // const index = hotSpotArray.indexOf(max);
      let hightlightKey = ""
      hotSpotArray.forEach(item => hightlightKey = Object.keys(item).reduce((prevValue, currValue) => item[prevValue] > item[currValue] ? prevValue : currValue))

      setHighestIndexHotspot(hightlightKey);
    }
  }, [hotSpotArray]);
  const formObj = {
    powderatomization: {
      value: powderAtomization,
      name: "PowderAtomization",
    },
    powderatomizationinput: {
      value: powderAutomizationInput,
      name: "PowderAtomizationInput",
    },
    volumerpareduction: {
      value: volumePArtReduction,
      name: "volumereduction",
    },
    volumerpareductioninput: {
      value: volumePartReductionInput,
      name: "volumereductioninput",
    },
    co2epowder: {
      value: co2ePowder,
      name: "co2epowder",
    },
    GreenenergyMix: {
      value: greenenergymix,
      name: "greenenergymix",
    },
    GreenenergyMixInput: {
      value: greenEnergyMixInput,
      name: "greenEnergyMixInput",
    },
    inertGas: {
      value: inertGasReduction,
      name: "EnergySystem",
    },

    co2transportation: {
      value: co2Transportation,
      name: "co2transportation",
    },
    co2totaltoday: {
      value: co2TotalToday,
      name: "co2totaltoday",
    },
    co2totaltomorrow: {
      value: co2TotalTomorrow,
      name: "co2totalToco2TotalTomorrow",
    },
    machinename: {
      value: MachineNameMD,
      name: "Machine Name",
    },
    materialname: {
      value: MaterialNameMD,
      name: "Machine Name",
    },
    co2eperjob: {
      value: co2ePerJobMFG,
      name: "co2eperjob",
    },
    co2eperpartpmfg: {
      value: co2ePerPartbMFG,
      name: "co2eperpartpmfg",
    },
    inertgasconsumption: {
      value: inertGasConsumptionIG,
      name: "inertGasConsumptionIG",
    },
    inertgasusedenergy: {
      value: inertGaUSedEnergyIG,
      name: "inertGaUSedEnergyIG",
    },
    energybuildprocess: {
      value: energyBuildProcessEC,
      name: "energyBuildProcessEC",
    },
    energyperpart: {
      value: energyPerPartEC,
      name: "energyPerPartEC",
    },
    co2peryeart: {
      value: co2PerYearT,
      name: "co2PerYearT",
    },
    co2perpartt: {
      value: co2PerPartT,
      name: "co2PerPartT",
    },
    co2emissionbuildprocess: {
      value: co2EmissionBuildProcessCC,
      name: "co2EmissionBuildProcessCC",
    },

    ModeOfTransportNode1: {
      value: ModeOfTransportNode1,
      name: "ModeOfTransportNode1",
    },
    ModeOfTransportNode2: {
      value: ModeOfTransportNode2,
      name: "ModeOfTransportNode2",
    },
    ModeOfTranspotation1: {
      value: ModeOfTranspotation1,
      name: "ModeOfTranspotation1",
    },
    ModeOfTranspotation2: {
      value: ModeOfTranspotation2,
      name: "ModeOfTranspotation2",
    },


  };

  return (
    <>
      <ToastContainer />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {typedocument === 0 ? "Enter pdf name" : "Enter word doc name"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-section">
            <DebounceInput
              type="text"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => {
                setPdfName(e.target.value);
              }}
              onWheel={(e) => e.target.blur()}
              placeholder="Please enter name"
              value={pdfName}
            />
            {/* <p className="edit-icon value-unit">kg</p> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center w-100 gap-8">
            <button
              className="button1 button btn-black"
              onClick={handleClose}
            >
              Close
            </button>
            <Button
              disabled={pdfName.length === 0}
              className="button1 button btn-primary"
              onClick={() => {
                setSavePdf(true);
                handleClose();
              }}
            >
              Download
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="accordion">
        <div className="d-flex flex-column ">
          <div className="reports-detail-section">
            <Row className="m-0">
              <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40 ">
                  <p className="input-heading capitalize  report-section-heading">Machine Details</p>
                <div className="d-flex    gap-20">
                <div className="report-data-field">
                  <span className="report-data-field-text"> Machine:</span>
                    <span className=" black-color  report-data-field-value"> &nbsp;{MachineNameMD}</span>
                  </div>
                  <div className="report-data-field">
                    <span className="report-data-field-text">
                      Powder:
                      </span>
                    <span className=" black-color  report-data-field-value"> &nbsp;{MaterialNameMD}</span>
                  </div>
                </div>
                </div>
              </Col>
              {/* <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">
                    Machine Manufacturing (N/A)
                  </p>
                  <div className="report-data-field">currently not available</div>
                  <div className="report-data-field">currently not available</div>
                </div>
              </Col> */}
              <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">
                    Powder Manufacturing{" "}
                  </p>
                  <div className="d-flex    gap-20">
                    <div className="report-data-field">
                      <span className="report-data-field-text">CO2e per job:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{co2ePerJobMFG} (kgs)</span>
                    </div>
                    <div className="report-data-field">
                      <span className="report-data-field-text">CO2e per part :</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{co2ePerPartbMFG} (kgs)</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">Inert Gas </p>
                  <div className="d-flex    gap-20">
                    <div className="report-data-field">
                      <span className="report-data-field-text">Inert gas consumption:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{inertGasConsumptionIG} (m
                        <sup className="font-weight-bold">3</sup>/job)
                      </span>
                    </div>
                    <div className="report-data-field">
                      <span className="report-data-field-text">Inert gas used energy:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{inertGaUSedEnergyIG} (kWh)</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="m-0 report-detail-inner-spacing">
              <Col lg={12} className="p-0 ">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">
                    Electricity Consumption
                  </p>
                  <div className="d-flex    gap-20">
                    <div className="report-data-field">
                      <span className="report-data-field-text">Energy build process:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{energyBuildProcessEC} (kWh/job)</span>
                    </div>
                    <div className="report-data-field">
                      <span className="report-data-field-text">Energy per part:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{energyPerPartEC} (kWh/part)</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">Logistics</p>
                  <div className="d-flex    gap-20">
                    <div className="report-data-field">
                      <span className="report-data-field-text">CO2e per part:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{co2PerPartT} (kg)</span>
                    </div>
                    <div className="report-data-field">
                      <span className="report-data-field-text">CO2e per year:</span>
                      <span className=" black-color  report-data-field-value"> &nbsp;{co2PerYearT} (kg)</span>
                    </div>
                  </div>
                </div>
              </Col>
              {/* <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">
                    Post Processing (N/A)
                  </p>
                  <div className="report-data-field">currently not available</div>
                  <div className="report-data-field">currently not available</div>
                </div>
              </Col>
              <Col lg={12} className="p-0">
                <div className="report-detailt-card mb-40">
                  <p className="input-heading capitalize  report-section-heading">
                    Used Powder - End of Life (N/A)
                  </p>
                  <div className="report-data-field">currently not available</div>
                  <div className="report-data-field">currently not available</div>
                </div>
              </Col> */}
            </Row>
          </div>
        </div>
        <div className="powder-container m-0" >
            <p className="font-32 font-semi-bold mb-24">Scenario Analysis</p>
          <div className="d-flex flex-row">
            {/* <MaterialTable Socket={socket} /> */}
            {/* <MaterialTableValues Socket={socket} /> */}
            <MaterialTableValues1 Socket={socket} isBold />
          </div>
          <div className="powder-table-top report-scenario-bg" >
            <p className=" font-24 font-semi-bold" style={{ width: "528px" }}>
              Total (kg)
            </p>
            <div className="d-flex ">
              <p className=" font-14 font-weight-bold"  style={{ width: "272px" }}>{co2TotalToday}</p>
              <p className="font-14 font-weight-bold">{co2TotalTomorrow}</p>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center w-100">
          <div className="graph-section width--mod">
            <p className="font-16 font-semi-bold mb-16">
              CO2e in % of kg per part
            </p>
            <p className="font-14">Current Scenario</p>
            <div
              className="d-flex flex-row "
              style={{ padding: " 24px 34px 16px 34px" }}
            >
              <div
                id="m2"
                className=" d-flex justify-content-center align-items-center"
              >
                <PieChart
                  animationDuration={500}
                  animationEasing="ease-out"
                  // center={[50, 50]}
                  width=" 300px"
                  height="300px"
                  data={DataSet}
                  labelPosition={110}
                  lengthAngle={360}
                  lineWidth={40}
                  paddingAngle={2}
                  radius={pieChartDefaultProps.radius - shiftSize}

                  // radius={PieChart.defaultProps.radius - shiftSize}
                  startAngle={0}
                  // label={({ dataEntry }) => dataEntry.title}
                  // // segmentsShift={(index) => (index === 3 ? shiftSize : 0.2)}

                  // labelStyle={{
                  //   fill: "black",
                  //   strokeWidth: "10",
                  //   fontSize: "5px",
                  //   fontFamily: "Open Sans, sans-serif",
                  //   fontWeight: "600",
                  // }}
                />
              </div>
              <div className="d-flex justify-content-center flex-column gap-8 ">
                {DataSet?.map((item) => (
                  <div className=" d-flex flex-row gap-4" >
                    <span className="font-14">{item.name}:</span>
                    <span className="font-14 font-weight-bold">{item.title}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-8 ">
          <div className="d-flex">
            <div className="color-icon bg-color5" />
            <p className="color-rep-value">CO2e Powder</p>
          </div>
          {/* TODO.. */}
          {/* <div className="d-flex">
            <div className="color-icon tomorrowBg4" />
            <p className="color-rep-value">CO2e Gas</p>
          </div> */}
          <div className="d-flex">
            <div className="color-icon bg-color7" />
            <p className="color-rep-value ">CO2e Energy</p>
          </div>
          <div className="d-flex">
            <div className="color-icon bg-color1" />
            <p className="color-rep-value m-0">CO2e Logistics</p>
          </div>
        </div>
          </div>
        </div>

        <ReportsTwo highestindex={highestIndexHotspot} />
        {/* <div className="d-flex justify-content-center align-items-center">
          <ConsultingTeam navigate={email} />
          <Dropdown> */}
            {/* <Button
              className="selection-button step-button"
              id="dropdown-basic"
              onClick={() => {
                setTypeDocument(0);
                handleShow();
              }}
            >
              Download Report
            </Button> */}
            {/* TODO... */}

            {/* <Dropdown.Toggle
              className="selection-button step-button"
              id="dropdown-basic"
            >
              Download Report
            </Dropdown.Toggle> */}

            {/* // TODO */}

            {/* <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => {
                  setTypeDocument(0);
                  handleShow();
                }}
              >
                As Pdf
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setTypeDocument(1);
                  handleShow();
                }}
              >
                As Word
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          </div> */}
        </div>


      {savePdf && (
        <PdfGenerator
          formFields={formObj}
          pdfName={pdfName}
          donutImage={donutImage}
          typeDocument={typedocument}
          HotsspotArray={HotsspotArray}
          highestIndex={highestIndexHotspot}
          initialDocumentState={initialDocumentState}
        />
      )}
    </>
  );
};

export default ReportsMetal;
